import React from 'react'

import useFetch from 'hooks/useFetch'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { PdcaForm } from './components'

import * as service from 'service'

const PdcaShow = ({ match }) => {
  const { pdcaId } = match.params

  const { response, isLoading } = useFetch(
    service.dponet.pdca.show,
    { pdcaId },
    [pdcaId],
    !!pdcaId,
  )

  const DataPdca = response?.data?.monitoringManagementPdca

  return (
    <Page title="Exibir PDCA">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoading} />
        <ContentHeader title="Exibição de PDCA" />
        {!isLoading && <PdcaForm dataPdca={DataPdca} mode="show" />}
      </Container>
    </Page>
  )
}

export default PdcaShow
